/**
 * Main.js
 *
 * @since 1.0.0
 */

import 'objectFitPolyfill'
import 'smoothscroll'
import objectFitImages from 'object-fit-images'
// import Raven from 'raven-js'
import ObserveFontFace from './modules/ObserveFontFace'
import FormValidation from './modules/FormValidation'
import SendForm from './modules/SendForm'
import DependsOn from './modules/DependsOn'
import UploadButton from './modules/UploadButton'
import LazyLoadImage from './modules/LazyLoadImage'
import LazyLoadPicture from './modules/LazyLoadPicture'
import LazyLoadVideo from './modules/LazyLoadVideo'
import GoogleMap from './modules/Map'
import ReadMore from './modules/ReadMore'
import StickyHeader from './modules/StickyHeader'
import Click from './modules/Click'
import MobileNav from './modules/MobileNav'
import SendLoginForm from './modules/SendLoginForm'
import SwipeSlider from './modules/SwipeSlider'
import SwipeOneSlider from './modules/SwipeOneSlider'
import Lightbox from './modules/Lightbox'
import ChildClick from './modules/ChildClick'
import Video from './modules/Video'
import VideoPopup from './modules/VideoPopup'
import ProductSlider from './modules/ProductSlider'
import Wishlist from './modules/Wishlist'
import Parallax from './modules/Parallax'
import ThumbnailSlider from './modules/ThumbnailSlider'
import Tabs from './modules/Tabs'
import Blur from './modules/Blur'
import CarVideo from './modules/CarVideo'
;(function IIFE() {
  // if (process.env.NODE_ENV === 'production') {
  // Raven
  // .config('')
  // .install()
  // }
  ObserveFontFace()
  objectFitImages()
  FormValidation()
  SendForm()
  DependsOn()
  UploadButton()
  LazyLoadImage()
  LazyLoadPicture()
  LazyLoadVideo()
  GoogleMap()
  ReadMore()
  StickyHeader()
  Click()
  MobileNav()
  SendLoginForm()
  SwipeSlider()
  SwipeOneSlider()
  Lightbox()
  ChildClick()
  Video()
  VideoPopup()
  ProductSlider()
  Wishlist()
  Parallax()
  ThumbnailSlider()
  Tabs()
  Blur()
  CarVideo()
})()



// WEBPACK FOOTER //
// ./src/js/main.js